export default __webpack_public_path__ + "7792cd63acc16414b96d2aa1f8ad4d74.svg";